import "./SalesHome.css";
import ViewCard from "../../../components/ViewCard/ViewCard";
import SalesDashboardCarousel from "../SalesDashboardCarousel/SalesDashboardCarousel";
import { ROLE_SECTIONS } from "../../../utils/sidebarURLs";

const SalesHome = () => {
    return (
        <div className="salesHome-father-div">
            <div className="salesHome-grid-container">
                {ROLE_SECTIONS.ventas.items.map((item) => {
                    if(item.title === 'Dashboard') return
                    return <ViewCard key={item.name} item={item}/>
                })}
            </div>
            <div className="salesHome-dashboard-fatherDiv">
                <SalesDashboardCarousel/>
            </div>
        </div>
    );
};
export default SalesHome;
